import * as UIUtil from "/app/js/util/UI.js";
import { getNoticeList } from "../notice/api/NoticeApi.js";
import * as NoticeDetail from "../notice/panel/NoticeDetail.js";
import * as Main from "../common/Menu.js";

export const open = async function () {
    const htmlUrl = `app/html/${document.documentElement.lang}/Main.html`;

    try {
        const response = await fetch(htmlUrl);
        const text = await response.text();
        const headerWrap = document.querySelector(".headerWrap");
        await headerWrap.insertAdjacentHTML('afterend', text);

        initEvt();
        setTimeout(drawList, 0);
    } catch (error) {
        console.error('HTML 로딩 중 오류 발생:', error);
        throw error;
    }
}

function initEvt() {
}

const drawList = async function () {
    const param = {
        rowSize: 20,
        currentPage: 1
    };

    const response = await getNoticeList(param);

    if (!response.SUCCESS) {
        UIUtil.msgBox("검색 실패", "error");
        return;
    }

    const { LIST } = response.RESULT;

    drawCardNews(LIST);
    drawGeotwoNews(LIST);
};

const drawCardNews = (list) => {
    const cardNewsList = list.filter(item =>
        item.category === 'Card News' && item.comNewsYn === 'Y'
    );

    const cardNewsUl = document.getElementById("cardNewsList");
    if (!cardNewsUl) return;
    cardNewsUl.innerHTML = "";

    cardNewsList.forEach(item => {
        const li = document.createElement("li");
        li.className = "slide";

        const imgSrc = item.noticeImgId
            ? `/notice/file/view/${item.noticeImgId}`
            : `/app/image/main/tmp-cardnews.jpg`;

        li.innerHTML = `
            <a title="카드뉴스 바로가기">
                <img src="${imgSrc}" alt="${item.title}">
            </a>
        `;
        cardNewsUl.appendChild(li);
        li.addEventListener("click", async function () {
            await Main.openMenu("Notice");
            NoticeDetail.open(item.noticeId);
        })


    });

    updateCardNewsCounter(cardNewsList.length);
};

const updateCardNewsCounter = (totalCount) => {
    const counterEl = document.querySelector(".slider-container .counter");
    if (!counterEl) return;

    const currentEl = counterEl.querySelector(".current");
    const totalEl = counterEl.querySelector(".total");

    currentEl.textContent = "1";
    totalEl.textContent = totalCount.toString();
};

const drawGeotwoNews = (list) => {
    const geotwoNewsList = list
        .filter(item => item.category === 'Geotwo News')
        .slice(0, 2);

    const geotwoNewsUl = document.getElementById("geotwoNewsList");
    if (!geotwoNewsUl) return;
    geotwoNewsUl.innerHTML = "";

    geotwoNewsList.forEach(item => {
        const li = document.createElement("li");

        const thumbnail = item.noticeImgId
            ? `/notice/file/view/${item.noticeImgId}`
            : '/app/image/main/tmp-news.jpg';

        const description = extractTextFromContent(item.content);

        li.innerHTML = `
            <div class="img-sec">
                <img src="${thumbnail}" alt="${item.title}">
            </div>
            <div class="txt-sec">
                <div class="tit">${item.title || ''}</div>
                <p class="desc">${description || '내용이 없습니다.'}</p>
                <div class="txt-info">
                    <span class="date">${item.registerDate || ''}</span>
                    <a class="link-more" title="더보기">more<i class="i-arrow-right"></i></a>
                </div>
            </div>
        `;
        geotwoNewsUl.appendChild(li);
        li.addEventListener("click", async function () {
            await Main.openMenu("Notice");
            NoticeDetail.open(item.noticeId);
        })
    });
};

const extractTextFromContent = (content) => {
    if (!content) return "";

    return content
        .replace(/<img[^>]*>/gi, '')
        .replace(/<table[^>]*>[\s\S]*?<\/table>/gi, '')
        .replace(/<\/?(ol|ul|li|div|p|span|a|font|b|i|u|sup|sub)[^>]*>/gi, '')
        .replace(/<[^>]+>/g, '')
        .replace(/\s+/g, ' ')
        .trim();
};